import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChequeReducer } from '../reducers';

export const selectChequeFeature = createFeatureSelector<ChequeReducer.ChequeState>(ChequeReducer.featureName);

export const selectCheque = createSelector(selectChequeFeature, (state: ChequeReducer.ChequeState) => state.item);
export const selectNewChequeBook = createSelector(selectChequeFeature, (state: ChequeReducer.ChequeState) => state.canCreateBook);
